import Script from 'next/script'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

const GOOGLE_SCRIPT = 'https://accounts.google.com/gsi/client'
const FACEBOOK_SCRIPT = 'https://connect.facebook.net/en_US/sdk.js'
export enum SocialLoginType {
    Google = 'Google',
    Facebook = 'Facebook'
}

declare global {
    interface Window {
        google: {
            accounts: {
                id: {
                    cancel: () => void
                    renderButton: (
                        ele: HTMLElement | null,
                        desc: {
                            type?: string
                            size?: string
                        }
                    ) => void
                    initialize: (data: {
                        client_id?: string
                        callback?: (data: { credential: string }) => void
                        cancel_on_tap_outside?: boolean
                    }) => void
                }
            }
        }
        FB: {
            init: (info: {
                appId: string
                cookie: boolean
                xfbml: boolean
                version: string
            }) => void
            getLoginStatus: (
                info: ({ status }: { status: any }) => void
            ) => void
            logout: () => void
            login: (
                fn: (response: {
                    authResponse: { accessToken: string }
                }) => void,
                detail: { scope: 'email' }
            ) => void
        }
    }
}
export const SocialLoginScript = () => {
    const config = useStoreConfig()
    const socialLoginConfig = config.base.socialLogin

    return (
        <>
            {socialLoginConfig.facebook.enabled && (
                <Script
                    async
                    defer
                    /* eslint-disable-next-line i18next/no-literal-string */
                    crossOrigin="anonymous"
                    src={FACEBOOK_SCRIPT}
                    onLoad={() => {
                        window.FB.init({
                            appId: socialLoginConfig.facebook.appId,
                            cookie: true, // Enable cookies to allow the server to access the session.
                            xfbml: true, // Parse social plugins on this webpage.
                            version: 'v17.0' // Use this Graph API version for this call.
                        })
                    }}
                />
            )}
            {socialLoginConfig.google.enabled && (
                <Script src={GOOGLE_SCRIPT} async />
            )}
        </>
    )
}
